var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('org-count-by-direction',{attrs:{"items":_vm.data,"total":_vm.data.length}})}
var staticRenderFns = []

export { render, staticRenderFns }